export default "__VITE_ASSET__B2BzdoaQ__"